module.exports = __webpack_public_path__ + "static/media/Lato-Medium.cecc32d2.eot";